import { apiClient } from './client';
import type {
  TransferRequest,
  TransactionFilters,
  TransactionResponse,
  TransactionStatsResponse
} from '@/types/transaction';

/**
 * Transaction API
 * Handles battery transaction operations
 */

/**
 * Transfer batteries from warehouse to driver
 */
export const transferToDriver = async (data: TransferRequest) => {
  const response = await apiClient.post('/batteries/transfer', data);
  return response.data;
};

/**
 * Get all transactions with filters
 */
export const getTransactions = async (filters?: TransactionFilters): Promise<TransactionResponse> => {
  const response = await apiClient.get('/transactions', {
    params: filters
  });
  return response.data;
};

/**
 * Get transactions by driver ID
 */
export const getDriverTransactions = async (driverId: number, page = 1, limit = 50): Promise<TransactionResponse> => {
  const response = await apiClient.get(`/transactions/driver/${driverId}`, {
    params: { page, limit }
  });
  return response.data;
};

/**
 * Get transactions by battery ID
 */
export const getBatteryTransactions = async (batteryId: number, page = 1, limit = 50): Promise<TransactionResponse> => {
  const response = await apiClient.get(`/transactions/battery/${batteryId}`, {
    params: { page, limit }
  });
  return response.data;
};

/**
 * Get transaction statistics
 */
export const getTransactionStats = async (startDate?: string, endDate?: string): Promise<TransactionStatsResponse> => {
  const response = await apiClient.get('/transactions/stats', {
    params: { startDate, endDate }
  });
  return response.data;
};
